import { render, staticRenderFns } from "./projectAmount.vue?vue&type=template&id=600ee9da&scoped=true&"
import script from "./projectAmount.vue?vue&type=script&lang=js&"
export * from "./projectAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ee9da",
  null
  
)

export default component.exports